
import zhCN from './zh-CN/common';
import en from './en/common';

export const resources = {
  'zh-CN': {
    common: zhCN
  },
  en: {
    common: en
  }
};

export default resources;
